import React, { useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
    Typography
} from '@mui/material'
import moment from 'moment'
import 'moment/locale/id'
import axios from 'axios'
import apiUrl from '../../configs/constant';
import { useToast } from '../../components/ToastProvider'
import DialogPenerimaan from './DialogPenerimaan'


interface Props {
    open: boolean
    mode: String
    data?: any
    doc_type?: String
    doc_id?: any
    onClose: () => void
}

const today = () => new Date().toISOString().split('T')[0]

const formatNumber = (value: string) => {
    const raw = value.replace(/[^0-9,]/g, '')
    const parts = raw.split(',')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return parts.join(',')
}

export default function DialogInvoice({
    open,
    mode,
    data,
    doc_type,
    doc_id,
    onClose,
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [listCustomer, setListCustomer] = useState<any[]>([])
    const [selectedData, setSelectedData] = useState<any>(null)

    const [customer, setCustomer] = useState<any>(null)
    const [modeDialog, setModeDialog] = useState<any>(null)
    const [tanggalJt, setTanggalJt] = useState<string>('')
    const [tgl, setTgl] = useState<string>('')
    const [total, setTotal] = useState<string>('')
    const [keterangan, setKeterangan] = useState<string>('')

    const [openPenerimaan, setOpenPenerimaan] = useState(false)

    useEffect(() => {
        if (!open) return

        if (mode === 'edit') {
            setCustomer(data?.customer ?? null)
            setTanggalJt(data?.tgl_jth_tempo.substring(0, 10) ?? today())
            setTgl(data?.tgl ?? today())
            setTotal(formatNumber(String(data?.total ?? '')))
            setKeterangan(data?.keterangan ?? '')
        } else if (mode == 'add-from-list') {
            setTanggalJt(today())
            setTgl(today())
            setTotal(data?.default_dp ?? 0)
            setKeterangan(data?.default_dp_pesan ?? '')
        } else {
            setCustomer(null)
            setTanggalJt(today())
            setTgl(today())
            setTotal('')
            setKeterangan('')
        }

        getCustomer(data?.sdcust_id)

        setModeDialog(mode)
        setSelectedData(data)

    }, [mode, data, open])

    const getCustomer = (ids: any) => {
        let url = apiUrl.apiUrl + '/acc/dp-customer/get-customer'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach(element => {
                        if (element.id == ids) {
                            setCustomer(element)
                        }
                    });
                    setListCustomer(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setSelectedData(data)
                    setModeDialog('edit')
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleSubmit = () => {
        const payload = {
            sdcust_id: customer?.id ?? null,
            nama_customer: customer?.nama ?? '',
            tgl_jth_tempo: tanggalJt,
            total: modeDialog == 'add' || modeDialog == 'edit' ? total.replace(/\./g, '').replace(',', '.') : total,
            doc_type: doc_type ?? null,
            doc_id: doc_id ?? null,
            keterangan
        }

        const url =
            modeDialog === 'add' || modeDialog === 'add-from-list'
                ? apiUrl.apiUrl + '/acc/dp-customer/store-dp'
                : apiUrl.apiUrl + '/acc/dp-customer/update-dp/' + selectedData.id

        axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success')

            const id = res.data.id

            setModeDialog('edit')
            getDetail(id)
        })

    }


    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>
                    {modeDialog === 'add' || modeDialog === 'add-from-list' ? 'Buat DP Pembayaran' : 'Edit DP Pembayaran'}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant='body1' sx={{ textAlign: 'left', width: '100%' }}>
                                Tanggal : <b>{moment(tgl).locale('id').format('DD MMMM YYYY')}</b>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                options={listCustomer}
                                value={customer}
                                disabled={modeDialog == 'add' || modeDialog == 'edit' ? false : true}
                                isOptionEqualToValue={(opt, val) => opt.id === val.id}
                                getOptionLabel={(o) => o?.nama ?? ''}
                                onChange={(_, val) => setCustomer(val)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Customer" />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Tanggal Jatuh Tempo"
                                type="date"
                                value={tanggalJt}
                                onChange={(e) => setTanggalJt(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Total"
                                value={total}
                                onChange={(e) => setTotal(formatNumber(e.target.value))}
                                fullWidth
                                inputProps={{ inputMode: 'numeric' }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Keterangan"
                                multiline
                                rows={2}
                                value={keterangan}
                                onChange={(e) => setKeterangan(e.target.value)}
                                fullWidth
                            />
                        </Grid>

                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleSubmit}
                            >
                                {modeDialog === 'add' || modeDialog === 'add-from-list' ? 'SIMPAN' : 'UPDATE'}
                            </Button>
                        </Grid>

                        {selectedData?.id && modeDialog === 'edit' && (
                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    fullWidth
                                    onClick={() =>
                                        window.open(
                                            `${apiUrl.baseUrl}/acc/dp-customer/pdf/${selectedData.id}`,
                                            '_blank'
                                        )
                                    }
                                >
                                    DOWNLOAD TAGIHAN
                                </Button>
                            </Grid>
                        )}

                        {selectedData?.id && modeDialog === 'edit' && (
                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    color="success"
                                    fullWidth
                                    onClick={() => {
                                        setOpenPenerimaan(true)
                                    }}
                                >
                                    {selectedData?.tgl_cair ? 'LIHAT PENERIMAAN' : 'BUAT PENERIMAAN'}
                                </Button>
                            </Grid>
                        )}

                        {selectedData?.id && modeDialog === 'edit' && (
                            <>
                                <Grid item xs={6}>
                                    <Button
                                        variant="outlined"
                                        color="success"
                                        fullWidth
                                        onClick={() => {
                                            window.open(
                                                `${apiUrl.baseUrl}/acc/mutasi-kas-bank/pdf/${selectedData?.accmutasi_id}`,
                                                '_blank'
                                            )
                                        }}
                                    >
                                        CETAK BKM A5
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="outlined"
                                        color="success"
                                        fullWidth
                                        onClick={() => {
                                            window.open(
                                                `${apiUrl.baseUrl}/acc/mutasi-kas-bank/pdf-a6/${selectedData?.accmutasi_id}`,
                                                '_blank'
                                            )
                                        }}
                                    >
                                        CETAK BKM A6
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </DialogActions>
            </Dialog>

            <DialogPenerimaan
                open={openPenerimaan}
                mode={selectedData?.tgl_cair == null ? 'create' : 'edit'}
                data={selectedData}
                onClose={() => {
                    setOpenPenerimaan(false)
                    getDetail(selectedData?.id)
                }}
            />
        </>
    )
}
